import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FieldModel } from '../model/field.model';

export function mismatchValidatorOld(controlToCompare: AbstractControl): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value || !controlToCompare.value) {
			return null;
		}
		return control.value !== controlToCompare.value ? { mismatch: true } : null;
	};
}

export function mismatchValidator(pathToCompareControl: string, schemaConfig?: FieldModel): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		let response = null;

		if (pathToCompareControl === null || pathToCompareControl === '') {
			return null;
		}

		const compareControl = control.root.get(pathToCompareControl) as FormControl;
		if (!control.value || !compareControl.value) {
			return null;
		}

		if (control.value !== compareControl.value) {
			response = {
				mismatch: {
					message: schemaConfig.UIOptions?.validatorsOptions?.mismatch?.errorMessage || `This field does not match with ${pathToCompareControl}`
				}
			};
		}

		return response;
	};
}
